module.exports = __webpack_public_path__ + "static/img/10.e3336a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/10.png
// module id = HBGi
// module chunks = 0